var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosGoogleAds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 65,
    viewBox: "0 0 67 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.541 47.0275L23.785 5.90652C26.6105 7.70279 40.8585 16.2172 43.1595 17.8366L20.9155 58.9598C18.4828 62.4302 -1.541 52.2939 1.541 47.0252V47.0275Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4517 47.0266L43.2077 5.90822C40.0979 0.319911 33.4005 -1.71091 27.8995 1.58967C22.3984 4.89026 20.7234 12.0001 23.8332 17.838L46.0772 58.9615C49.1869 64.5473 55.8845 66.5778 61.3856 63.2775C66.6462 59.9766 68.5614 52.6147 65.4517 47.0315V47.0266Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 64.8666C17.3328 64.8666 22.3319 59.6025 22.3319 53.109C22.3319 46.6154 17.3328 41.3513 11.166 41.3513C4.99918 41.3513 0 46.6154 0 53.109C0 59.6025 4.99918 64.8666 11.166 64.8666Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 65,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGoogleAds);
export default __webpack_public_path__ + "static/media/logos_google-ads.0d48029bd9c88777b93d35dab46cb28a.svg";
export { ForwardRef as ReactComponent };